import { useState } from "react";
import { toast } from "react-toastify";
import { createProjectAssignment } from "../../apis/projectApi";

export const useProjectAssignment = () => {
  const [assignLoading, setAssignLoading] = useState(false);
  const [assignError, setAssignError] = useState(null);
const extractError = (err) => {
  const res = err.response?.data;

  return {
    title: res?.message || "Assignment Failed",
    issue: res?.data || "Failed to assign user to project.",
  };
};

  const assignUserToProject = async (projectId, assignmentData) => {
    setAssignLoading(true);
    setAssignError(null);

    const toastId = toast.loading("Assigning user to project...");

    try {
      const payload = {
        project: projectId,
        user: assignmentData.user,
        access_level: assignmentData.access_level,
        responsibilities: assignmentData.responsibilities?.trim() || null,
        start_date: assignmentData.start_date || null,
        end_date: assignmentData.end_date || null,
        remark: assignmentData.remark?.trim() || null,
      };

      const response = await createProjectAssignment(payload);

      toast.update(toastId, {
        render: (
          <div>
            <strong>User Assigned</strong>
            <div>User assigned to project successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3200,
      });

      return response.data; // assuming axios response
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5500,
      });

      setAssignError({ title, issue });
      throw err;
    } finally {
      setAssignLoading(false);
    }
  };

  return {
    assignLoading,
    assignError,
    assignUserToProject,
  };
};